import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const Step1Root = styled('div', {
  paddingBottom: '$4',
  px: '$3',
  $$headerHeight: '80px',
  $$stepperHeight: '130px',
  $$mobileStepperHeight: '74px',
  $$footerHeight: '373px',
  '& label': {
    display: 'block',
  },

  '@bp1': {
    minHeight: 'calc(100vh - $$headerHeight - $$mobileStepperHeight - $$footerHeight)',
  },

  '@bp2': {
    minHeight: 'calc(100vh - $$headerHeight - $$stepperHeight - $$footerHeight)',
    px: '120px',
  },
})

export const BirthDateSelectWrapper = styled(Stack, {
  width: '100%',
  paddingTop: '8px',
  
  '& div > button': {
    minWidth: '100px',
    width: '100%',
  },

  '& div': {
    flex: 1,
  }
})